import { render } from "./UserNameLabel.vue?vue&type=template&id=20eb1f96&ts=true"
import script from "./UserNameLabel.vue?vue&type=script&lang=ts"
export * from "./UserNameLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__